import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";

import { useCombinedContext } from "../../context/CombinedContext";
import exportToExcel from "../Excel/ExportToExcel";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import PurchaseView from "./PurchaseView";
import PurchaseForm from "./PurchaseForm";

const PurchaseList = () => {
  const [purchase, setPurchase] = useState([]);
  const [vessel, setVessel] = useState([]);

  const [filterData, setFilterData] = useState([]);
  const [fromDate, setFromDate] = useState(""); // Start date for filtering
  const [toDate, setToDate] = useState(""); // End date for filtering
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [isViewMode, setIsViewMode] = useState(false);
  const [selectedYear, setSelectedYear] = useState(""); // For year-wise filtering
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const { selectesVessel, selectedCompany } = useCombinedContext();
  const companyId = selectedCompany?._id;
  const companyCode = selectedCompany?.company_code;

  // console.log("for gst",selectedCompany)
  // console.log(purchase, "Purchase data  for excel");
  //  console.log("companyId: ", companyId);
  // console.log("vessel", vessel)

  const fetchPurchase = async () => {
    try {
      setLoading(true);
      const params = {};
      if (fromDate) params.start_date = fromDate;
      if (toDate) params.end_date = toDate;

      const response = await axiosInstance.get(
        `/logistics/purchase/${companyId}`,
        {
          params,
        },
      );
      // If response.data is not an array, try to extract the array from a property (e.g., response.data.purchases)
      // console.log("purchase", response);
      const dataArray = Array.isArray(response.data.data)
        ? response.data.data
        : response.data.purchases || [];
      setPurchase(dataArray);
      setFilterData(dataArray);
    } catch (error) {
      toast.error("Error fetching purchase");
    } finally {
      setLoading(false);
    }
  };

  const fetchVessel = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/logistics/vessel/company/${companyId}`,
      );
      setVessel(response.data.vessels || []);
      // console.log("Vessel", response);
      // console.log("companyId: ", companyId);
    } catch (error) {
      // console.error("Error fetching purchase:", error);
      toast.error("Error fetching Vessel");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if(companyId){
  //     fetchPurchase();
  //   }
  // }, [companyId]);

  useEffect(() => {
    if (companyId) {
      fetchPurchase();
    }
  }, [companyId, fromDate, toDate]);

  const handleSearchChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    const filteredLocation = purchase.filter(
      (purchase) =>
        purchase.invoiceNo?.toString().toLowerCase().includes(searchText) ||
        purchase.shopName?.toString().toLowerCase().includes(searchText) ||
        purchase.invoiceDate?.toString().toLowerCase().includes(searchText),
    );
    setFilterData(filteredLocation);
  };

  const deleteCompany = async (_id) => {
    try {
      await axiosInstance.delete(`/logistics/purchase/${_id}`);
      fetchPurchase();
    } catch (error) {
      // console.error("Error deleting company:", error);
      toast.error("Failed to delete conpany");
    }
  };

  const handleDelete = (id) => {
    // console.log("delete", id);
    setDeleteTarget(id);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await axiosInstance.delete(`/logistics/purchase/${deleteTarget}`);
      setPurchase((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setFilterData((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setIsDeleteModalOpen(false);
      setDeleteTarget(null);
      toast.success("Location deleted successfully");
    } catch (error) {
      // console.error("Error deleting location:", error);
      toast.error("Failed to delete location");
    }
  };

  // Get data from selected year
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    if (year) {
      setFromDate(`${year}-01-01`);
      setToDate(`${year}-12-31`);
    } else {
      setFromDate("");
      setToDate("");
    }
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };
  // const itemsPerPage = 5;
  const currentPurchaseItems = [...filterData]
    .reverse()
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  const pageCount = Math.ceil(filterData.length / itemsPerPage);

  //Check Role

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));

  const userRole = authData.role;

  const handleExport = () => {
    const sheetData = [];
    const merges = [];

    // Define multi-row headers.
    // Row 0: Main headers. The "Items" header spans columns 4 to 8.
    sheetData.push([
      "Sl No",
      "Invoice No",
      "Shop Name",
      "Invoice Date",
      "Items",
      "", // placeholder for Description
      "", // placeholder for Quantity
      "", // placeholder for Unit Price
      "", // placeholder for Amount
      "Total Amount",
      "Remarks",
    ]);

    // Row 1: Sub-headers for the items section.
    sheetData.push([
      "",
      "",
      "",
      "",
      "Part No",
      "Item",
      "Description",
      "Quantity",
      "Unit Price",
      "Amount",
      "",
      "",
    ]);

    // Merge cells for headers that span multiple rows.
    merges.push(
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // Sl No
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // Invoice No
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // Shop Name
      { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } }, // Invoice Date
      { s: { r: 0, c: 9 }, e: { r: 1, c: 9 } }, // Total Amount
      { s: { r: 0, c: 10 }, e: { r: 1, c: 10 } }, // Remarks
    );

    // Merge the "Items" header across columns 4 to 9.
    merges.push({ s: { r: 0, c: 4 }, e: { r: 0, c: 9 } });

    // Process each purchase in filterData.
    // (Assume filterData is an array of purchase objects like your sample.)
    filterData.forEach((purchase, index) => {
      const startRow = sheetData.length; // Remember where this purchase's rows start.
      // Format dates
      const invoiceDate = new Date(purchase.invoiceDate).toLocaleDateString();

      // Loop through each item in the purchase.
      purchase.items.forEach((item, itemIndex) => {
        sheetData.push([
          itemIndex === 0 ? index + 1 : "", // Sl No (only for the first row)
          itemIndex === 0 ? purchase.invoiceNo : "", // Invoice No
          itemIndex === 0 ? purchase.shopName : "", // Shop Name
          itemIndex === 0 ? invoiceDate : "", // Invoice Date
          item.stock?.stockNo || "", // Part No
          item.item, // Item name
          item.description, // Description
          item.quantity, // Quantity
          item.unitPrice, // Unit Price
          item.amount, // Amount
          itemIndex === 0 ? purchase.totalAmount : "", // Total Amount (merged)
          itemIndex === 0 ? purchase.remarks : "", // Remarks (merged)
        ]);
      });

      const endRow = sheetData.length - 1;
      // If there are multiple items, merge the purchase-level cells vertically.
      if (purchase.items.length > 1) {
        [0, 1, 2, 3, 9, 10, 11].forEach((col) => {
          merges.push({ s: { r: startRow, c: col }, e: { r: endRow, c: col } });
        });
      }
    });

    // Convert the array of arrays into a worksheet.
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    // Apply the merges.
    worksheet["!merges"] = merges;

    // (Optional) Apply basic styles, for example to add borders or bold headers.
    Object.keys(worksheet).forEach((cellKey) => {
      if (cellKey[0] === "!") return;
      // Bold if the cell value is part of header rows.
      const cell = worksheet[cellKey];
      if (cell && sheetData[0].includes(cell.v)) {
        cell.s = {
          font: { bold: true },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    // Create a new workbook and append the worksheet.
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate a binary string representation of the workbook.
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    // Create a blob and trigger a download.
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, "exported_data.xlsx");
  };

  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  const requestApproval = async (id) => {
    try {
      await axiosInstance.post(`/logistics/purchase/request-approval/${id}`);
      toast.success("Approval requested");
      fetchPurchase(); // refresh list
    } catch (err) {
      toast.error(err.response?.data?.message || "Error");
    }
  };

  const handleApprove = async (id) => {
    try {
      await axiosInstance.patch(`/logistics/purchase/approve/${id}`);
      toast.success("Edit approved successfully");
      fetchPurchase(); // refresh list
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to approve edit request",
      );
    }
  };

  return (
    <div>
      <ToastContainer />

      {/*  <div style={{ flex: "0 1 auto" }}>
          <Link to="/logistics/stocklist">
            <button className="button-2">Stock List</button>
          </Link>
        </div>
        <div style={{ flex: "0 1 auto" }}>
          <Link to="/logistics/purchase-report">
            <button className="button-2">Report</button>
          </Link>
        </div>
        <div style={{ flex: "0 1 auto" }}>
          <Link to="/logistics/stockoutlist">
            <button className="button-2">Stock Out List</button>
          </Link>
        </div> */}
      <div className="mb-4 headStyle d-flex  justify-content-between align-items-center">
        <h4 className="mb-0">Purchase</h4>
        <button
          className="button-2"
          onClick={() => {
            if (selectedCompany?.status === false) {
              toast.error(
                "The selected company is inactive. Cannot add a purchase.",
              );
            } else {
              setSelectedData(null);
              setShowForm(true);
            }
          }}
          style={{
            borderRadius: "8px",
            whiteSpace: "nowrap",
            padding: "8px 16px",
          }}
        >
          Add Purchase
        </button>
      </div>
      <div className="headStyle">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <label
                htmlFor="fromDate"
                style={{ width: "-webkit-fill-available" }}
              >
                From Date
              </label>
              <input
                className="form-control"
                type="date"
                placeholder="From Date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <label
                htmlFor="fromDate"
                style={{ width: "-webkit-fill-available" }}
              >
                To Date
              </label>
              <input
                className="form-control"
                type="date"
                placeholder="To Date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <div>
              <select
                className="form-select"
                value={selectedYear}
                onChange={handleYearChange}
                // size={30}
                style={{
                  width: "70px", // Adjust the width
                  maxHeight: "300px !importent", // Limit the height of the dropdown
                  overflowY: "auto", // Add scroll for long lists
                }}
              >
                <option value="">Year</option>
                {Array.from(
                  { length: new Date().getFullYear() - 2000 + 1 },
                  (_, i) => 2000 + i,
                ).map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

          </div>
        </div>

        {/* Right Side: Add Purchase Button */}
      </div>
      <div className="headStyle mt-4 ">
        <div className="d-flex mt-2 flex-wrap align-items-center gap-3 justify-content-between">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div>
              <input
                className="form-control"
                type="search"
                placeholder="Search..."
                style={{
                  maxWidth: "100%",
                  border: "1px solid #1E2A5E",
                  borderRadius: "8px",
                }}
                onChange={handleSearchChange}
              />
            </div>
            <div className="d-flex align-items-center">
              <label className="me-2 pt-1">Count</label>
              <select
                className="form-select no-arrow"
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                style={{ width: "auto" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
              </select>
            </div>
          </div>
          <div style={{ flex: "0 1 auto" }}>
            <button className="button-2 exxportBtn" onClick={handleExport}>
              Export to Excel
            </button>
          </div>
        </div>
        <div
          className="my-3 rounded table-responsive-sm"
          style={{
            overflowX: "auto",
          }}
        >
          <table id="my-table" className="table table-bordered mb-0">
            <thead className="t_head">
              <tr className="text-center align-middle">
                {/* Table Headers */}
                <th className="align-middle">Sl No</th>
                <th className="align-middle">Invoice No</th>
                <th className="align-middle">Shop Name</th>
                <th className="align-middle">Invoice Date</th>
                <th className="align-middle">Total Amount</th>
                <th className="align-middle">Remarks</th>
                <th className="align-middle">Status</th>
                <th className="text-center align-middle ">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8">
                    <div className="d-flex justify-content-center m-3">
                      <div className="spinner"></div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {currentPurchaseItems.length === 0 ? (
                    <>
                      <tr>
                        <td colSpan="8">
                          <div className="d-flex justify-content-center m-1">
                            <h6>Data Not Found</h6>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {currentPurchaseItems &&
                        currentPurchaseItems.map((purchase, index) => (
                          <tr key={purchase._id || index}>
                            {/* Table Data */}
                            <td style={{ textAlign: "center" }}>
                              {currentPage * itemsPerPage + index + 1}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {purchase.invoiceNo || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {purchase.shopName || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {purchase.invoiceDate
                                ? new Date(
                                  purchase.invoiceDate,
                                ).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              $ {formatPrice(purchase.totalAmount) || "N/A"}
                            </td>

                            <td style={{ textAlign: "center" }}>
                              {purchase.remarks || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {purchase.editRequestPending
                                ? "🔴 Pending"
                                : purchase.editApproved
                                  ? "🟢 Approved"
                                  : "—"}
                            </td>
                            <td>
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                {["admin", "superadmin"].includes(userRole) && (
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => {
                                      setSelectedData(purchase);
                                      setIsViewMode(true);
                                    }}
                                  >
                                    <i className="bi bi-folder2-open"></i>
                                  </button>
                                )}
                                {!(
                                  userRole === "user" &&
                                  purchase.userEditCount > 0 &&
                                  !purchase.editApproved
                                ) && (
                                    <button
                                      className="btn btn-outline-success btn-sm"
                                      onClick={() => {
                                        setSelectedData(purchase);
                                        setShowForm(true);
                                      }}
                                    >
                                      <i className="bi bi-pencil-square"></i>
                                    </button>
                                  )}
                                {userRole === "user" &&
                                  purchase.userEditCount > 0 &&
                                  !purchase.editApproved && (
                                    <>
                                      {purchase.editRequestPending ? (
                                        <span className="badge bg-danger">
                                          Pending
                                        </span>
                                      ) : (
                                        <button
                                          className="approvalBtn"
                                          onClick={() =>
                                            requestApproval(purchase._id)
                                          }
                                        >
                                          Request Approval
                                        </button>
                                      )}
                                    </>
                                  )}
                                {["admin", "superadmin"].includes(userRole) &&
                                  purchase.editRequestPending && (
                                    <button
                                      className="btn btn-outline-primary btn-sm"
                                      onClick={() =>
                                        handleApprove(purchase._id)
                                      }
                                    >
                                      Approve
                                    </button>
                                  )}
                                {["admin", "superadmin"].includes(userRole) && (
                                  <button
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() => handleDelete(purchase._id)}
                                  >
                                    <i className="bi bi-trash3"></i>
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          containerClassName="pagination justify-content-center pagination-sm"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
        />
        {isViewMode && (
          <PurchaseView
            purchase={selectedData}
            isViewMode={isViewMode}
            userRole={userRole}
            setIsViewMode={setIsViewMode}
          />
        )}
        {showForm && (
          <PurchaseForm
            purchase={selectedData}
            companyCode={companyCode}
            companyId={companyId}
            vessel={vessel}
            selectedCompany={selectedCompany}
            onClose={() => {
              setShowForm(false);
              fetchPurchase();
            }}
          />
        )}
        {isDeleteModalOpen && (
          <div
            className={`modal fade ${isDeleteModalOpen ? "show d-block" : ""}`}
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="deleteModalLabel"
            aria-hidden={!isDeleteModalOpen}
            onClick={(e) => {
              if (e.target.classList.contains("modal"))
                setIsDeleteModalOpen(false);
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="deleteModalLabel">
                    Confirm Deletion
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setIsDeleteModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body modalWhite">
                  Are you sure you want to delete this Purchase? This action
                  cannot be undone.
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setIsDeleteModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PurchaseList;
